<template>
    <router-view />
</template>

<script>
// import {codeToSession} from '@/service/session.js';
import request from "@/utils/request.js";

export default {
    name: 'CommonLayerLayout',
    components: {},
    data() {
        return {};
    },
    created() {
        const vm = this;
        // 这里目前用来处理一些公共的前端逻辑，
        // 目前就是，从Cookies中读取AppCode，扩展到request对象中
        // console.log('CommonLayerLayout#setCookie', JSESSIONID);
        const tokenKey = `${vm.$cookies.get("App-Code")}-token`;
        // if (JSESSIONID) {
        request.extendOptions({
            headers: {
                "App-Code": vm.$cookies.get("App-Code"),
                [tokenKey]: vm.$cookies.get(tokenKey)
            }
        });
    },
}
</script>

<style lang="less"></style>